import Cookies from 'js-cookie';

export default function newsletter() {

  const newsletter_viewed = Cookies.get( 'smeth_newsletter' );
	if ( !newsletter_viewed ) {
		$.magnificPopup.open({
			items: {
				src: '#newsletter',
				type: 'inline'
			},
      closeOnBgClick: false,
      enableEscapeKey: false
		});
		Cookies.set( 'smeth_newsletter', true, { expires: 7 } );
	}
	
	$('.link-newsletter a').click(function(e){
    e.preventDefault();

    $('.newsletter-form').show();
    $('.newsletter-success').hide();
    $('#sme-thailand-newsletter-sign-up')[0].reset();

		$('#header .hamburger').toggleClass( 'is-active' );
		$( '.nav-container' ).toggleClass( 'active' );
		$( 'body' ).toggleClass( 'menu-open' );
    
    $.magnificPopup.open({
      items: {
        src: $(this).attr('href'),
        type: 'inline'
      },
      closeOnBgClick: false,
      enableEscapeKey: false
    });
  });

  $('#sme-thailand-newsletter-sign-up').on('submit', function (e) {
    // Prevent default browser actions on form submission.
    e.preventDefault();
    // Get all the form user submitted data and get it ready to be sent.
    var data = $(this).serialize();
    // POST all the data to the SMF submission endpoint URL.
    $.ajax({
      type: 'POST',
      url: 'https://subs.sonymusicfans.com/submit',
      dataType: 'json',
      data: data,
      xhrFields: {
        withCredentials: false
      },
      success: function (data) {
        // Do things on successful submission.
        $('.newsletter-form').hide();
        $('.newsletter-success').show();
      },
      error: function (err) {
        // Do things when submission has an error.
        alert('An error has occurred!');
      }
    });
  });
  
}